// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  width: 97%;
  height: 200px;
  background: var(--dark-blue);
  border-radius: 20px;
  margin-bottom: 20px;
  margin-top: 80px;
  color: white;
  display: flex;
  justify-content: space-around;
  padding: 30px 20px;
  font-size: 14px;
}
.footer .content-footer .text {
  margin-bottom: 10px !important;
}
.footer .content-footer .text:hover {
  cursor: pointer;
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/Benchmarking/Scss/Footer.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,aAAA;EACA,4BAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,6BAAA;EACA,kBAAA;EACA,eAAA;AACF;AACI;EACE,8BAAA;AACN;AACI;EACE,eAAA;EACA,0BAAA;AACN","sourcesContent":[".footer {\n  width: 97%;\n  height: 200px;\n  background: var(--dark-blue);\n  border-radius: 20px;\n  margin-bottom: 20px;\n  margin-top: 80px;\n  color: white;\n  display: flex;\n  justify-content: space-around;\n  padding: 30px 20px;\n  font-size: 14px;\n  .content-footer {\n    .text {\n      margin-bottom: 10px !important;\n    }\n    .text:hover {\n      cursor: pointer;\n      text-decoration: underline;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
